<template>
  <Navbar :center-text="$t('ManageUsersView.manageUsers')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container mt-4 w-100">
    <FileExport :filename="this.exportFilename"
                :data="this.exportData">
    </FileExport>

    <div class="row justify-content-center">
      <div class="col-md-12 col-sm-12 ">
        <table class="table table-bordered table-hover table-striped table-responsive">
          <thead class="table-light">
          <tr>
            <th>{{ $t('ManageUsersView.status') }}</th>
            <th>{{ $t('email') }}</th>
            <th>{{ $t('role') }}</th>
            <th>{{ $t('ManageUsersView.farmerCodes') }}</th>
            <th>{{ $t('actions') }}</th>
          </tr>
          </thead>
          <tbody>
          <!-- Existing Users -->
          <tr v-for="user in users">
            <td>
              <div class="form-check form-switch"
                   v-if="user.id !== sharedState.user_id">
                <label class="form-check-label">
                  <input type="checkbox"
                         name="status"
                         class="form-check-input"
                         v-model="user.isActive"/>
                  {{ $t('ManageUsersView.active') }}
                </label>
              </div>

            </td>
            <td class="text-start">{{ user.email }}</td>
            <td>
              <multiselect v-if="user.id !== sharedState.user_id"
                           placeholder=""
                           v-model="user.role"
                           :options="allRoles"
                           :custom-label="roleSelectLabel"
                           :searchable="false"
                           :close-on-select="true"
                           :show-labels="false"></multiselect>
            </td>
            <td style="text-align: left;">
              <Multiselect v-if="user.role.id !== '9e75cccf-089a-11f0-9634-005056853737'" placeholder=""
                           v-model="user.assigned_farms"
                           :options="unassignedFarms"
                           :custom-label="farmSelectLabel"
                           :multiple="true"
                           :searchable="true"
                           :close-on-select="true"
                           :clear-on-select="true"
                           :show-labels="false"
                           track-by="__id"></Multiselect>
              <span v-if="user.role.id === '9e75cccf-089a-11f0-9634-005056853737'"
                    v-for="farm in user.assigned_farms"
                    class="badge bg-success m-1">
                {{ farm.label }}
              </span>
            </td>
            <td>
              <div v-if="user.id !== sharedState.user_id">
                <button class="m-1 btn btn-success btn-sm"
                        @click="saveUser(user)">
                  <i class="bi bi-plus-circle"></i> {{ $t('save') }}
                </button>
                <button class="m-1 btn btn-warning btn-sm"
                        @click="resetPassword(user)">
                  <i class="bi bi-eraser"></i> {{ $t('PasswordResetView.passwordReset') }}
                </button>
                <button v-if="user.role !== 'Administrator'"
                        class="m-1 btn btn-danger btn-sm"
                        @click="deleteUser(user)">
                  <i class="bi bi-trash"></i> {{ $t('delete') }}
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

<!--    <div class="row justify-content-center">-->
<!--      <div class="col col-12">-->
<!--        <button class="btn btn-primary w-100"-->
<!--                v-if="!showNewUserFields"-->
<!--                @click="toggleNewUserFields">-->
<!--          <i class="bi bi-plus"></i> {{ $t('addNewUser') }}-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="row justify-content-center">-->
<!--      <div class="col col-12">-->
<!--        <table v-if="showNewUserFields"-->
<!--               class="table table-bordered table-hover table-striped table-responsive">-->
<!--          <thead class="table-light">-->
<!--          <tr>-->
<!--            <th colspan="5"-->
<!--                scope="colgroup">-->
<!--              {{ $t('addNewUser') }}-->
<!--            </th>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <th scope="col">{{ $t('status') }}</th>-->
<!--            <th scope="col">{{ $t('email') }}</th>-->
<!--            <th scope="col">{{ $t('role') }}</th>-->
<!--            <th scope="col">{{ $t('farmerCodes') }}</th>-->
<!--            <th scope="col">{{ $t('actions') }}</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr>-->
<!--            <td>-->
<!--              <div class="form-check form-switch">-->
<!--                <input type="checkbox"-->
<!--                       id="newStatus"-->
<!--                       name="newStatus"-->
<!--                       class="form-check-input"-->
<!--                       v-model="newUser.isActive"/>-->
<!--                <label class="form-check-label"-->
<!--                       for="newStatus">-->
<!--                  {{ $t('active') }}-->
<!--                </label>-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>-->
<!--              <input type="email"-->
<!--                     class="form-control rounded-pill"-->
<!--                     v-model="newUser.email"-->
<!--                     :placeholder="$t('email')"-->
<!--                     required>-->
<!--            </td>-->
<!--            <td>-->
<!--              <multiselect placeholder=""-->
<!--                           v-model="newUser.role"-->
<!--                           :options="allRoles"-->
<!--                           :custom-label="roleSelectLabel"-->
<!--                           :searchable="false"-->
<!--                           :close-on-select="true"-->
<!--                           :show-labels="false"></multiselect>-->
<!--            </td>-->
<!--            <td>-->
<!--              <Multiselect placeholder=""-->
<!--                           v-model="newUser.assignedFarms"-->
<!--                           :options="unassignedFarms"-->
<!--                           :custom-label="farmSelectLabel"-->
<!--                           :multiple="true"-->
<!--                           :searchable="true"-->
<!--                           :close-on-select="true"-->
<!--                           :clear-on-select="true"-->
<!--                           :show-labels="false"-->
<!--                           track-by="__id"></Multiselect>-->
<!--            </td>-->
<!--            <td>-->
<!--              <button class="m-1 btn btn-success btn-sm"-->
<!--                      @click="addNewUser">-->
<!--                <i class="bi bi-plus-circle"></i> {{ $t('add') }}-->
<!--              </button>-->
<!--              <button class="m-1 btn btn-danger btn-sm"-->
<!--                      @click="toggleNewUserFields">-->
<!--                <i class="bi bi-trash"></i> {{ $t('ManageUsersView.cancel') }}-->
<!--              </button>-->
<!--            </td>-->
<!--          </tr>-->

<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->
<!--    </div>-->


  </div>
  <Footerbar></Footerbar>
</template>

<script>
import axios from "axios";
import {sharedState} from "@/store";
import {
  API_BASE_URL,
  deleteUserData,
  getAllFarms,
  getAllRoles,
  getAllUsers,
  postReset,
  postUserData,
  putUserData
} from "@/utils";
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import Multiselect from "vue-multiselect";
import FileExport from "@/components/FileExport.vue";

export default {
  data() {
    return {
      users: [],
      allFarms: [],
      unassignedFarms: [],
      allRoles: [],
      showNewUserFields: false,
      newUser: {},
      sharedState,
      message: null,
      messageType: null,
      exportFilename: "",
      exportData: {},
    };
  },
  components: {
    sharedState,
    FileExport,
    Footerbar,
    Navbar,
    Multiselect,
  },
  methods: {
    farmSelectLabel({id, label}) {
      return `${label}`
    },

    roleSelectLabel({id, name}) {
      return `${name}`;
    },

    async getUsers() {
      let response = await getAllUsers();
      if (response.status === 200) {
        this.users = response.data;
        let today = new Date().toISOString().slice(0, 10);
        this.exportFilename = today + "-CANALLS-Users";
        this.exportData = this.users;
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },

    async saveUser(user) {
      let response = await putUserData(user.id, user);
      if (response.status === 200) {
        this.message = `User ${user.email} updated successfully!`;
        this.messageType = "success";
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },

    async resetPassword(user) {
      let response = await postReset(user.email);
      if (response.status === 200) {
        this.message = `Password of user ${user.email} was reset!`;
        this.messageType = "success";
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },

    async deleteUser(user) {
      const confirmed = confirm(`Are you sure you want to permanently delete ${user.email}?`);
      if (confirmed) {
        let response = await deleteUserData(user.id);
        if (response.status === 200) {
          this.users = this.users.filter(currentUser => currentUser.id !== user.id);
          this.message = `User ${user.email} deleted successfully!`;
          this.messageType = "success";
        } else {
          this.message = response.response.data.message;
          this.messageType = "danger";
        }
      }
    },

    toggleNewUserFields() {
      this.showNewUserFields = !this.showNewUserFields;
      this.newUser = {};
    },

    async addNewUser() {
      let response = await postUserData(this.newUser);
      if (response.status === 201) {
        await this.getUsers();
        this.newUser = {};
        this.message = `User ${this.newUser.email} created successfully!`;
        this.messageType = "success";
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }

    }
    /*
    startNewUser() {
      // Starte die Erstellung eines neuen Benutzers
      this.newUser = {
        username: "",
        role: "User",
        farmerCodes: "",
        password: "",
      };
    },
    async saveNewUser() {
      if (!this.newUser.username || !this.newUser.password) {
        alert("Please provide a username and password.");
        return;
      }

      // Konvertiere Farmer Codes in ein Array
      this.newUser.farmerCodes = this.stringToArray(this.newUser.farmerCodes);

      // Füge den neuen Benutzer hinzu (API-Aufruf)
      await axios.post("http://localhost:5000/users", this.newUser);

      // Benutzer zur lokalen Liste hinzufügen
      this.users = {
        ...this.users, // Vorhandene Benutzer beibehalten
        [this.newUser.username]: {...this.newUser},
      };

      // Eingabezeile zurücksetzen
      this.newUser = null;
      alert("New user added successfully!");
    },
    arrayToString(array) {
      // Wandelt ein Array in einen kommagetrennten String um
      return Array.isArray(array) ? array.join(", ") : "";
    },
    stringToArray(string) {
      // Überprüfen, ob der Wert ein String ist
      if (typeof string !== "string") {
        return Array.isArray(string) ? string : []; // Wenn es ein Array ist, gib es zurück, ansonsten leeres Array
      }
      return string
          .split(",")
          .map((code) => code.trim())
          .filter((code) => code);
    },
    updateFarmerCodes(event, username) {
      // Aktualisiert die Farmer Codes eines Benutzers bei Eingabe
      const value = event.target.value;
      this.users[username].farmerCodes = this.stringToArray(value);
    },
    cancelNewUser() {
      this.newUser = null; // Eingabezeile schließen
    },
    */
  },
  async mounted() {
    let farmResponse = await getAllFarms();
    if (farmResponse.status === 200) {
      this.allFarms = farmResponse.data;
      this.unassignedFarms = this.allFarms.filter(function (farm) {
        return farm.advisor_farmer === "";
      });
    } else if (farmResponse.status === 204) {
      this.allFarms = [];
      this.unassignedFarms = [];
    } else {
      this.message = farmResponse.response.data.message;
      this.messageType = "danger";
    }

    let roleResponse = await getAllRoles();
    if (roleResponse.status === 200) {
      this.allRoles = roleResponse.data;
    } else {
      this.message = roleResponse.response.data.message;
      this.messageType = "danger";
    }

    await this.getUsers();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
